import { createApi } from '@reduxjs/toolkit/query/react';

import {
  DebugEndpoints as Endpoints,
  type CancelDelayedCommandRequest,
  type CancelDelayedCommandResponse,
  type CancelDelayedCommandsRequest,
  type CancelDelayedCommandsResponse,
  type ClearPriorityIntegrationsRequest,
  type ClearPriorityIntegrationsResponse,
  type GetAllDelayedCommandsRequest,
  type GetAllDelayedCommandsResponse,
  type GetClientMessageInfoRequest,
  type GetClientMessageInfoResponse,
  type GetCommandsByActionRequest,
  type GetCommandsByActionResponse,
  type PushMessageInBrokerMessageRequest,
  type PushMessageInBrokerMessageResponse,
} from '@app/api/Debug/types';
import { createApiBaseQuery, Methods } from '@app/api/shared';

const DEBUG_RESOURCE = 'Debug';

export const debugApi = createApi({
  reducerPath: 'debugApi',
  baseQuery: createApiBaseQuery(DEBUG_RESOURCE),
  endpoints: ({ query, mutation }) => ({
    [Endpoints.GetClientMessageInfo]: query<
      GetClientMessageInfoResponse,
      GetClientMessageInfoRequest
    >({
      query: (params) => ({
        url: Endpoints.GetClientMessageInfo,
        method: Methods.GET,
        params,
      }),
    }),
    [Endpoints.ClearPriorityIntegrations]: mutation<
      ClearPriorityIntegrationsResponse,
      ClearPriorityIntegrationsRequest
    >({
      query: (params) => ({
        url: Endpoints.ClearPriorityIntegrations,
        method: Methods.POST,
        params,
      }),
    }),
    [Endpoints.PushMessageInBrokerMessage]: mutation<
      PushMessageInBrokerMessageResponse,
      PushMessageInBrokerMessageRequest
    >({
      query: ({ data, ...params }) => ({
        url: Endpoints.PushMessageInBrokerMessage,
        method: Methods.POST,
        params,
        data,
      }),
    }),
    [Endpoints.CancelDelayedCommands]: mutation<
      CancelDelayedCommandsResponse,
      CancelDelayedCommandsRequest
    >({
      query: (params) => ({
        url: Endpoints.CancelDelayedCommands,
        method: Methods.POST,
        params,
      }),
    }),
    [Endpoints.CancelDelayedCommand]: mutation<
      CancelDelayedCommandResponse,
      CancelDelayedCommandRequest
    >({
      query: (params) => ({
        url: Endpoints.CancelDelayedCommand,
        method: Methods.POST,
        params,
      }),
    }),
    [Endpoints.GetCommandsByAction]: query<
      GetCommandsByActionResponse,
      GetCommandsByActionRequest
    >({
      query: (params) => ({
        url: Endpoints.GetCommandsByAction,
        method: Methods.GET,
        params,
      }),
    }),
    [Endpoints.GetAllDelayedCommands]: query<
      GetAllDelayedCommandsResponse,
      GetAllDelayedCommandsRequest
    >({
      query: (params) => ({
        url: Endpoints.GetAllDelayedCommands,
        method: Methods.GET,
        params,
      }),
    }),
  }),
});

export const {
  useGetClientMessageInfoQuery,
  useLazyGetClientMessageInfoQuery,
  useClearPriorityIntegrationsMutation,
  usePushMessageInBrokerMessageMutation,
  useCancelDelayedCommandsMutation,
  useCancelDelayedCommandMutation,
  useGetCommandsByActionQuery,
  useLazyGetCommandsByActionQuery,
  useGetAllDelayedCommandsQuery,
  useLazyGetAllDelayedCommandsQuery,
} = debugApi;
